import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const problems = [
  { pre: "Still servicing your bike ", hl: "after hearing a sound", post: "?" },
  { pre: "Still ", hl: "don't trust your mechanic", post: " with your bike?" },
  { pre: "Still unsure ", hl: "which brand to trust", post: " when buying parts?" },
  { pre: "Still paying a ", hl: "30–40% premium", post: " for overpriced genuine parts?" },
  { pre: "Still facing ", hl: "parts unavailability", post: "?" },
  { pre: "Still ", hl: "wasting time", post: " at your mechanic?" },
];

export default function SavingsBanner() {
  return (
    <section
      data-testid="problems-section"
      className="relative py-24 md:py-32 px-6 md:px-12 bg-[#16191F] border-y border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 flex items-center justify-center">
        <div className="radial-spot-amber h-[80%] w-[80%] max-w-[700px]" />
      </div>

      <div className="max-w-5xl mx-auto">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="max-w-3xl mb-14"
        >
          <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            The problems we aim to solve.
          </h2>
        </motion.div>

        <motion.ul
          variants={stagger(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6"
        >
          {problems.map((p, i) => (
            <motion.li
              key={i}
              variants={fadeUp}
              data-testid={`problem-${i + 1}`}
              className="flex items-start gap-4 border-b border-white/5 pb-6"
            >
              <span className="mt-1 font-display text-lg font-bold text-[#D9544E] shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="font-display text-xl sm:text-2xl font-medium leading-snug text-[#F4F1ED]">
                {p.pre}
                <span className="text-[#D9544E]">{p.hl}</span>
                {p.post}
              </p>
            </motion.li>
          ))}
        </motion.ul>

        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          data-testid="problems-closing"
          className="mt-14 font-display text-2xl sm:text-3xl font-medium text-[#E7B459] max-w-3xl"
        >
          Raahi is built to save you the time, effort and second-guessing.
        </motion.p>
      </div>
    </section>
  );
}
